// tslint:disable:max-line-length

/************************************************************************************/
/* WARNING: This file is generated automatically. Don't edit it by hand             */
/************************************************************************************/

import type * as rest from "../rest";
import type * as t from "./admin.generated.types";

function enc(s: any) { return encodeURIComponent("" + s); }

export interface IAdmin {
    /** Get single dummy invoice file. This endpoint is used for testing and should not be called otherwise. */
    getDummyInvoice(req: t.IGetDummyInvoiceReq): Promise<t.IGetDummyInvoiceRes>;

    /** Render single invoice again */
    rerenderSingleInvoice(req: t.IRerenderSingleInvoiceReq): Promise<t.IRerenderSingleInvoiceRes>;

    /** Pre-render single invoice - doesn't need to be unissued */
    infoRenderSingleInvoice(req: t.IInfoRenderSingleInvoiceReq): Promise<t.IInfoRenderSingleInvoiceRes>;

    /** Pre-render proforma invoice email body and subject for preview */
    infoRenderProformaEmail(req: t.IInfoRenderProformaEmailReq): Promise<t.IInfoRenderProformaEmailRes>;

    /** Delete invoice record for specified invoice id */
    deleteInvoice(req: t.IDeleteInvoiceReq): Promise<t.IDeleteInvoiceRes>;

    /** Get next invoice number for given year */
    getNextInvoiceNumberForYear(req: t.IGetNextInvoiceNumberForYearReq): Promise<t.IGetNextInvoiceNumberForYearRes>;

    /** Issues new manual invoice */
    issueManualInvoice(req: t.IIssueManualInvoiceReq): Promise<t.IIssueManualInvoiceRes>;

    /** Prepares new invoices */
    prepareNewInvoices(req: t.IPrepareNewInvoicesReq): Promise<t.IPrepareNewInvoicesRes>;

    /** Renders missing invoices */
    renderMissingInvoices(req: t.IRenderMissingInvoicesReq): Promise<t.IRenderMissingInvoicesRes>;

    /** Finalizes invoices */
    finalizeInvoices(req: t.IFinalizeInvoicesReq): Promise<t.IFinalizeInvoicesRes>;

    /** Downloads a batch of rendered invoices */
    downloadBatchOfInvoices(req: t.IDownloadBatchOfInvoicesReq): Promise<t.IDownloadBatchOfInvoicesRes>;

    /** Downloads a csv for a batch of invoices */
    downloadCsvOfInvoices(req: t.IDownloadCsvOfInvoicesReq): Promise<t.IDownloadCsvOfInvoicesRes>;

    /** Get available invoice types */
    getInvoiceTypes(req: t.IGetInvoiceTypesReq): Promise<t.IGetInvoiceTypesRes>;

    /** Search invoices with optional filter criteria such as date range, user or room. */
    getInvoices(req: t.IGetInvoicesReq): Promise<t.IGetInvoicesRes>;

    /** Get single message for specified id */
    getSingleMessage(req: t.IGetSingleMessageReq): Promise<t.IGetSingleMessageRes>;

    /** Update single message for specified id */
    updateSingleMessage(req: t.IUpdateSingleMessageReq): Promise<t.IUpdateSingleMessageRes>;

    /** Get all message */
    getMessages(req: t.IGetMessagesReq): Promise<t.IGetMessagesRes>;

    /** Insert new message */
    insertNewMessage(req: t.IInsertNewMessageReq): Promise<t.IInsertNewMessageRes>;

    /** Insert new payment */
    insertNewPayment(req: t.IInsertNewPaymentReq): Promise<t.IInsertNewPaymentRes>;

    /** Cancel payment */
    cancelPayment(req: t.ICancelPaymentReq): Promise<t.ICancelPaymentRes>;

    /** Search payments with optional filter criteria, such as user or date range */
    getPayments(req: t.IGetPaymentsReq): Promise<t.IGetPaymentsRes>;

    /** Get the list of latest changes in reservations, such as new additions and deletions */
    getLatestChanges(req: t.IGetLatestChangesReq): Promise<t.IGetLatestChangesRes>;

    /** Get status of the given background job */
    getJobStatus(req: t.IGetJobStatusReq): Promise<t.IGetJobStatusRes>;

    /** Get balances for all active users */
    getUserBalances(req: t.IGetUserBalancesReq): Promise<t.IGetUserBalancesRes>;

    /** Get monthly report such as cumulative income, total number of reservations, reservations by room and by user etc. */
    getMonth(req: t.IGetMonthReq): Promise<t.IGetMonthRes>;

    /** Search reservations with criteria such as user, date range or room */
    getReservations(req: t.IGetReservationsReq): Promise<t.IGetReservationsRes>;

    /** Search history of reservation changes. Only used for diagnostics. */
    getReservationsHistory(req: t.IGetReservationsHistoryReq): Promise<t.IGetReservationsHistoryRes>;

    /** Get list of all users */
    getUsers(req: t.IGetUsersReq): Promise<t.IGetUsersRes>;

    /** Insert single new user */
    insertSingleUser(req: t.IInsertSingleUserReq): Promise<t.IInsertSingleUserRes>;

    /** Get deletion ratio for given month for all users */
    getUsersDeletionRatio(req: t.IGetUsersDeletionRatioReq): Promise<t.IGetUsersDeletionRatioRes>;

    /** Recalculates statuses for all users */
    recalculateAllUserStatuses(req: t.IRecalculateAllUserStatusesReq): Promise<t.IRecalculateAllUserStatusesRes>;

    /** Gets all available price-lists */
    getPricelists(req: t.IGetPricelistsReq): Promise<t.IGetPricelistsRes>;

    /** Get yearly KPI */
    getKpiYear(req: t.IGetKpiYearReq): Promise<t.IGetKpiYearRes>;

    /** Get general ledger content for single user */
    getSingleUserGl(req: t.IGetSingleUserGlReq): Promise<t.IGetSingleUserGlRes>;

    /** Get special prices for single user */
    getSingleUserSpecialPrices(req: t.IGetSingleUserSpecialPricesReq): Promise<t.IGetSingleUserSpecialPricesRes>;

    /** Get realization-ratio for single user */
    getSingleUserRealizationRatio(req: t.IGetSingleUserRealizationRatioReq): Promise<t.IGetSingleUserRealizationRatioRes>;

    /** Add special price for single user */
    addSingleUserSpecialPrice(req: t.IAddSingleUserSpecialPriceReq): Promise<t.IAddSingleUserSpecialPriceRes>;

    /** send JWT token that can be used for impersonation */
    impersonateUser(req: t.IImpersonateUserReq): Promise<t.IImpersonateUserRes>;

    /** Remove special price for single user */
    removeSingleUserSpecialPrice(req: t.IRemoveSingleUserSpecialPriceReq): Promise<t.IRemoveSingleUserSpecialPriceRes>;

    /** Get password for single user */
    setUserPwd(req: t.ISetUserPwdReq): Promise<t.ISetUserPwdRes>;

    /** Recalculates status for single user */
    recalculateSingleUserStatus(req: t.IRecalculateSingleUserStatusReq): Promise<t.IRecalculateSingleUserStatusRes>;

    /** Get basic information about a single user */
    getSingleUser(req: t.IGetSingleUserReq): Promise<t.IGetSingleUserRes>;

    /** Update single user */
    updateSingleUser(req: t.IUpdateSingleUserReq): Promise<t.IUpdateSingleUserRes>;

    /** Convert registration to full user */
    convertRegistration(req: t.IConvertRegistrationReq): Promise<t.IConvertRegistrationRes>;

    /** Deactivate registration */
    deactivateRegistration(req: t.IDeactivateRegistrationReq): Promise<t.IDeactivateRegistrationRes>;

    /** Search registrations */
    searchRegistrations(req: t.ISearchRegistrationsReq): Promise<t.ISearchRegistrationsRes>;

    /** Insert new registration */
    newRegistration(req: t.INewRegistrationReq): Promise<t.INewRegistrationRes>;

}

export class Admin implements IAdmin {

    private client: rest.IApiClient;

    constructor(client: rest.IApiClient) { this.client = client; }

    /** Get single dummy invoice file. This endpoint is used for testing and should not be called otherwise. */
    public async getDummyInvoice(req: t.IGetDummyInvoiceReq): Promise<t.IGetDummyInvoiceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoice/dummy`;
        return (await this.client.get(url, reqx));
    }

    /** Render single invoice again */
    public async rerenderSingleInvoice(req: t.IRerenderSingleInvoiceReq): Promise<t.IRerenderSingleInvoiceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoice/${enc(req.id)}/re-render`;
        delete reqx.id;
        return (await this.client.post(url, reqx));
    }

    /** Pre-render single invoice - doesn't need to be unissued */
    public async infoRenderSingleInvoice(req: t.IInfoRenderSingleInvoiceReq): Promise<t.IInfoRenderSingleInvoiceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoice/${enc(req.id)}/info-render`;
        delete reqx.id;
        return (await this.client.post(url, reqx));
    }

    /** Pre-render proforma invoice email body and subject for preview */
    public async infoRenderProformaEmail(req: t.IInfoRenderProformaEmailReq): Promise<t.IInfoRenderProformaEmailRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoice/${enc(req.id)}/info-render-proforma-email`;
        delete reqx.id;
        return (await this.client.post(url, reqx));
    }

    /** Delete invoice record for specified invoice id */
    public async deleteInvoice(req: t.IDeleteInvoiceReq): Promise<t.IDeleteInvoiceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoice/${enc(req.id)}`;
        delete reqx.id;
        return (await this.client.delete(url, reqx));
    }

    /** Get next invoice number for given year */
    public async getNextInvoiceNumberForYear(req: t.IGetNextInvoiceNumberForYearReq): Promise<t.IGetNextInvoiceNumberForYearRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoices/next-number`;
        return (await this.client.get(url, reqx));
    }

    /** Issues new manual invoice */
    public async issueManualInvoice(req: t.IIssueManualInvoiceReq): Promise<t.IIssueManualInvoiceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoices/issue-manual`;
        return (await this.client.post(url, reqx));
    }

    /** Prepares new invoices */
    public async prepareNewInvoices(req: t.IPrepareNewInvoicesReq): Promise<t.IPrepareNewInvoicesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoices/prepare-new`;
        return (await this.client.post(url, reqx));
    }

    /** Renders missing invoices */
    public async renderMissingInvoices(req: t.IRenderMissingInvoicesReq): Promise<t.IRenderMissingInvoicesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoices/render-missing`;
        return (await this.client.post(url, reqx));
    }

    /** Finalizes invoices */
    public async finalizeInvoices(req: t.IFinalizeInvoicesReq): Promise<t.IFinalizeInvoicesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoices/finalize`;
        return (await this.client.post(url, reqx));
    }

    /** Downloads a batch of rendered invoices */
    public async downloadBatchOfInvoices(req: t.IDownloadBatchOfInvoicesReq): Promise<t.IDownloadBatchOfInvoicesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoices/download-batch-docs`;
        return (await this.client.post(url, reqx));
    }

    /** Downloads a csv for a batch of invoices */
    public async downloadCsvOfInvoices(req: t.IDownloadCsvOfInvoicesReq): Promise<t.IDownloadCsvOfInvoicesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoices/download-batch-csv`;
        return (await this.client.post(url, reqx));
    }

    /** Get available invoice types */
    public async getInvoiceTypes(req: t.IGetInvoiceTypesReq): Promise<t.IGetInvoiceTypesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoice-types`;
        return (await this.client.get(url, reqx));
    }

    /** Search invoices with optional filter criteria such as date range, user or room. */
    public async getInvoices(req: t.IGetInvoicesReq): Promise<t.IGetInvoicesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/invoices`;
        return (await this.client.get(url, reqx));
    }

    /** Get single message for specified id */
    public async getSingleMessage(req: t.IGetSingleMessageReq): Promise<t.IGetSingleMessageRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/messages/${enc(req.id)}`;
        delete reqx.id;
        return (await this.client.get(url, reqx));
    }

    /** Update single message for specified id */
    public async updateSingleMessage(req: t.IUpdateSingleMessageReq): Promise<t.IUpdateSingleMessageRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/messages/${enc(req.id)}`;
        delete reqx.id;
        return (await this.client.put(url, reqx));
    }

    /** Get all message */
    public async getMessages(req: t.IGetMessagesReq): Promise<t.IGetMessagesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/messages`;
        return (await this.client.get(url, reqx));
    }

    /** Insert new message */
    public async insertNewMessage(req: t.IInsertNewMessageReq): Promise<t.IInsertNewMessageRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/messages`;
        return (await this.client.post(url, reqx));
    }

    /** Insert new payment */
    public async insertNewPayment(req: t.IInsertNewPaymentReq): Promise<t.IInsertNewPaymentRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/payments/new`;
        return (await this.client.post(url, reqx));
    }

    /** Cancel payment */
    public async cancelPayment(req: t.ICancelPaymentReq): Promise<t.ICancelPaymentRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/payments/cancel/${enc(req.id)}`;
        delete reqx.id;
        return (await this.client.post(url, reqx));
    }

    /** Search payments with optional filter criteria, such as user or date range */
    public async getPayments(req: t.IGetPaymentsReq): Promise<t.IGetPaymentsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/payments`;
        return (await this.client.get(url, reqx));
    }

    /** Get the list of latest changes in reservations, such as new additions and deletions */
    public async getLatestChanges(req: t.IGetLatestChangesReq): Promise<t.IGetLatestChangesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/latest_changes`;
        return (await this.client.get(url, reqx));
    }

    /** Get status of the given background job */
    public async getJobStatus(req: t.IGetJobStatusReq): Promise<t.IGetJobStatusRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/jobs/${enc(req.uuid)}`;
        delete reqx.uuid;
        return (await this.client.get(url, reqx));
    }

    /** Get balances for all active users */
    public async getUserBalances(req: t.IGetUserBalancesReq): Promise<t.IGetUserBalancesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/balances`;
        return (await this.client.get(url, reqx));
    }

    /** Get monthly report such as cumulative income, total number of reservations, reservations by room and by user etc. */
    public async getMonth(req: t.IGetMonthReq): Promise<t.IGetMonthRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/month`;
        return (await this.client.get(url, reqx));
    }

    /** Search reservations with criteria such as user, date range or room */
    public async getReservations(req: t.IGetReservationsReq): Promise<t.IGetReservationsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/reservations`;
        return (await this.client.get(url, reqx));
    }

    /** Search history of reservation changes. Only used for diagnostics. */
    public async getReservationsHistory(req: t.IGetReservationsHistoryReq): Promise<t.IGetReservationsHistoryRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/reservations-history`;
        return (await this.client.get(url, reqx));
    }

    /** Get list of all users */
    public async getUsers(req: t.IGetUsersReq): Promise<t.IGetUsersRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users`;
        return (await this.client.get(url, reqx));
    }

    /** Insert single new user */
    public async insertSingleUser(req: t.IInsertSingleUserReq): Promise<t.IInsertSingleUserRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users`;
        return (await this.client.post(url, reqx));
    }

    /** Get deletion ratio for given month for all users */
    public async getUsersDeletionRatio(req: t.IGetUsersDeletionRatioReq): Promise<t.IGetUsersDeletionRatioRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/deletion-ratio`;
        return (await this.client.get(url, reqx));
    }

    /** Recalculates statuses for all users */
    public async recalculateAllUserStatuses(req: t.IRecalculateAllUserStatusesReq): Promise<t.IRecalculateAllUserStatusesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/recalc-status`;
        return (await this.client.post(url, reqx));
    }

    /** Gets all available price-lists */
    public async getPricelists(req: t.IGetPricelistsReq): Promise<t.IGetPricelistsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/pricelists`;
        return (await this.client.get(url, reqx));
    }

    /** Get yearly KPI */
    public async getKpiYear(req: t.IGetKpiYearReq): Promise<t.IGetKpiYearRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/kpi/year`;
        return (await this.client.get(url, reqx));
    }

    /** Get general ledger content for single user */
    public async getSingleUserGl(req: t.IGetSingleUserGlReq): Promise<t.IGetSingleUserGlRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/${enc(req.user_uuid)}/gl`;
        delete reqx.user_uuid;
        return (await this.client.get(url, reqx));
    }

    /** Get special prices for single user */
    public async getSingleUserSpecialPrices(req: t.IGetSingleUserSpecialPricesReq): Promise<t.IGetSingleUserSpecialPricesRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/${enc(req.user_uuid)}/special-prices`;
        delete reqx.user_uuid;
        return (await this.client.get(url, reqx));
    }

    /** Get realization-ratio for single user */
    public async getSingleUserRealizationRatio(req: t.IGetSingleUserRealizationRatioReq): Promise<t.IGetSingleUserRealizationRatioRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/${enc(req.user_uuid)}/realization-ratio`;
        delete reqx.user_uuid;
        return (await this.client.get(url, reqx));
    }

    /** Add special price for single user */
    public async addSingleUserSpecialPrice(req: t.IAddSingleUserSpecialPriceReq): Promise<t.IAddSingleUserSpecialPriceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/${enc(req.user_uuid)}/special-prices-add`;
        delete reqx.user_uuid;
        return (await this.client.post(url, reqx));
    }

    /** send JWT token that can be used for impersonation */
    public async impersonateUser(req: t.IImpersonateUserReq): Promise<t.IImpersonateUserRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/${enc(req.user_uuid)}/impersonate`;
        delete reqx.user_uuid;
        return (await this.client.post(url, reqx));
    }

    /** Remove special price for single user */
    public async removeSingleUserSpecialPrice(req: t.IRemoveSingleUserSpecialPriceReq): Promise<t.IRemoveSingleUserSpecialPriceRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/${enc(req.user_uuid)}/special-prices-remove`;
        delete reqx.user_uuid;
        return (await this.client.post(url, reqx));
    }

    /** Get password for single user */
    public async setUserPwd(req: t.ISetUserPwdReq): Promise<t.ISetUserPwdRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/${enc(req.user_uuid)}/set-pwd`;
        delete reqx.user_uuid;
        return (await this.client.post(url, reqx));
    }

    /** Recalculates status for single user */
    public async recalculateSingleUserStatus(req: t.IRecalculateSingleUserStatusReq): Promise<t.IRecalculateSingleUserStatusRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/${enc(req.user_uuid)}/recalc-status`;
        delete reqx.user_uuid;
        return (await this.client.post(url, reqx));
    }

    /** Get basic information about a single user */
    public async getSingleUser(req: t.IGetSingleUserReq): Promise<t.IGetSingleUserRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/${enc(req.user_uuid)}`;
        delete reqx.user_uuid;
        return (await this.client.get(url, reqx));
    }

    /** Update single user */
    public async updateSingleUser(req: t.IUpdateSingleUserReq): Promise<t.IUpdateSingleUserRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/users/${enc(req.user_uuid)}`;
        delete reqx.user_uuid;
        return (await this.client.put(url, reqx));
    }

    /** Convert registration to full user */
    public async convertRegistration(req: t.IConvertRegistrationReq): Promise<t.IConvertRegistrationRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/registrations/${enc(req.id)}/convert`;
        delete reqx.id;
        return (await this.client.post(url, reqx));
    }

    /** Deactivate registration */
    public async deactivateRegistration(req: t.IDeactivateRegistrationReq): Promise<t.IDeactivateRegistrationRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/registrations/${enc(req.id)}/deactivate`;
        delete reqx.id;
        return (await this.client.post(url, reqx));
    }

    /** Search registrations */
    public async searchRegistrations(req: t.ISearchRegistrationsReq): Promise<t.ISearchRegistrationsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/registrations`;
        return (await this.client.get(url, reqx));
    }

    /** Insert new registration */
    public async newRegistration(req: t.INewRegistrationReq): Promise<t.INewRegistrationRes> {
        const reqx: any = req;
        const url = `/api/v1.0/admin/registrations`;
        return (await this.client.post(url, reqx));
    }

}
